import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeployConfigSchema, ReleaseChannelSchema, ReleaseEnvironmentSchema } from './shapes';

/**
 * Partial channel config: the desktop card sends tauriPackageId, the mobile
 * card sends the Firebase App Distribution fields (UCH-418).
 */
export const UpdateReleaseChannelBodySchema = z
  .object({
    tauriPackageId: z.string().trim().max(200).optional(),
    firebaseAppId: z.string().trim().max(200).optional(),
    firebaseAppIdIos: z.string().trim().max(200).optional(),
    fadTesterGroups: z.array(z.string().trim().min(1).max(200)).max(50).optional(),
    /** Slack channel id (C…, or G… for legacy private channels) for build notifications; '' clears it (UCH-804). */
    slackChannelId: z
      .string()
      .trim()
      .regex(/^([CG][A-Z0-9]{8,}|)$/, 'must be a Slack channel id (C… or G…)')
      .optional(),
    /** Publish deploy target; null clears it (Publish goes back to status-only). */
    deployConfig: DeployConfigSchema.nullable().optional(),
    /** Write-only ArgoCD API token, sealed server-side; null clears it. */
    deploySecret: z.string().trim().min(1).max(8192).nullable().optional(),
  })
  .strict();
export type UpdateReleaseChannelBody = z.infer<typeof UpdateReleaseChannelBodySchema>;

export const updateReleaseChannel = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-products/:productId/channels/:environment',
  params: z.object({ productId: z.string().uuid(), environment: ReleaseEnvironmentSchema }),
  query: z.object({}),
  body: UpdateReleaseChannelBodySchema,
  response: z.object({ data: ReleaseChannelSchema }),
});
